import { Checkbox, FormControlLabel, MenuItem, TextField } from "@mui/material";
import { AD_BUTTONS, LEAD_BUTTONS, isWebLink } from "./marketingFormat";

function ButtonSelect({ value, options, onChange }) {
  return (
    <TextField
      select
      label="Button"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      size="small"
    >
      {options.map((item) => (
        <MenuItem key={item.value} value={item.value}>
          {item.label}
        </MenuItem>
      ))}
    </TextField>
  );
}

function WebsiteFields({ form }) {
  const { fields, set } = form;
  return (
    <>
      <TextField
        label="Website address"
        value={fields.link}
        onChange={(e) => set("link")(e.target.value)}
        fullWidth
        size="small"
        error={fields.link !== "" && !isWebLink(fields.link)}
        helperText="Where people land, starting with https://"
      />
      <div className="grid grid-cols-2 gap-3">
        <TextField
          label="Headline (optional)"
          value={fields.headline}
          onChange={(e) => set("headline")(e.target.value)}
          size="small"
        />
        <ButtonSelect value={fields.button} options={AD_BUTTONS} onChange={set("button")} />
      </div>
    </>
  );
}

function LeadFields({ form }) {
  const { fields, set } = form;
  return (
    <>
      <p className="text-xs text-app-text-muted">
        Meta shows an instant form on the ad. It always asks name and email, and phone unless you
        untick it. Replies are collected in Meta (Page, Leads Center), not in this dashboard.
      </p>
      <TextField
        label="Privacy policy address"
        value={fields.privacyUrl}
        onChange={(e) => set("privacyUrl")(e.target.value)}
        fullWidth
        size="small"
        error={fields.privacyUrl !== "" && !isWebLink(fields.privacyUrl)}
        helperText="Required by Meta, starting with https://"
      />
      <div className="grid grid-cols-2 gap-3">
        <TextField
          label="Headline (optional)"
          value={fields.headline}
          onChange={(e) => set("headline")(e.target.value)}
          size="small"
        />
        <ButtonSelect value={fields.button} options={LEAD_BUTTONS} onChange={set("button")} />
      </div>
      <TextField
        label="Extra question (optional)"
        value={fields.question}
        onChange={(e) => set("question")(e.target.value)}
        fullWidth
        size="small"
        helperText="One free-text question, e.g. Which course are you interested in?"
      />
      <FormControlLabel
        control={
          <Checkbox
            size="small"
            checked={fields.askPhone}
            onChange={(e) => set("askPhone")(e.target.checked)}
          />
        }
        label="Ask for a phone number"
      />
    </>
  );
}

export default function AdGoalFields({ form }) {
  const { goal, welcome } = form.fields;
  if (goal === "WEBSITE") return <WebsiteFields form={form} />;
  if (goal === "LEADS") return <LeadFields form={form} />;
  if (goal === "MESSAGES") {
    return (
      <TextField
        label="Welcome message (optional)"
        value={welcome}
        onChange={(e) => form.set("welcome")(e.target.value)}
        fullWidth
        multiline
        minRows={2}
        size="small"
        helperText="Sent when someone taps Send message. The ad runs on Facebook only."
      />
    );
  }
  return (
    <p className="text-xs text-app-text-muted">
      Reach shows the ad to as many people as the budget allows and has no link or button.
    </p>
  );
}
